import React, { Component } from "react";
// 图标
import SunImg from "images/report/sun.png";
import MoonImg from "images/report/moon.png";
import MountainImg from "images/report/mountain.png";
import PentagonImg from "images/report/pentagon.png";
import TriangleImg from "images/report/triangle.png";
import RectangleImg from "images/report/rectangle.png";
import SnowImg from "images/report/snow.png";
import WaterImg from "images/report/water.png";

function App(props) {
    const { data, i18n } = props;
    const character = data.live_characteristics || data.char || {};
    const mood = data.live_emotions || data.emos || {};

    const emotionsTimes = i18n.lang == "en_us" ? 1.5 : 1.9;
    const dealWithNum = (num, times) => ((times || 1) * (num || 0)) + "px";


    return (
        <div className="bulk-wrap">
            <div className="bulk-item bulk-left">
                <div className="bulk-content">
                    <div className="bulk-content-title">{i18n.report.liveEmotions}：</div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.angry}</div>
                        <div className="mood-item-img">
                            <img className="img-sun" src={SunImg} />
                        </div>
                        <div className="mood-item-progress bgColor1" style={{width: dealWithNum(mood.angry, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.happines}</div>
                        <div className="mood-item-img">
                            <img className="img-moon" src={MoonImg} />
                        </div>
                        <div className="mood-item-progress bgColor2" style={{width: dealWithNum(mood.happines, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.fear}</div>
                        <div className="mood-item-img">
                            <img className="img-mountain" src={MountainImg} />
                        </div>
                        <div className="mood-item-progress bgColor3" style={{width: dealWithNum(mood.fear, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.disgust}</div>
                        <div className="mood-item-img">
                            <img className="img-pentagon" src={PentagonImg} />
                        </div>
                        <div className="mood-item-progress bgColor4" style={{width: dealWithNum(mood.disgust, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.contempt}</div>
                        <div className="mood-item-img">
                            <img className="img-triangle" src={TriangleImg} />
                        </div>
                        <div className="mood-item-progress bgColor5" style={{width: dealWithNum(mood.contempt, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.neutral}</div>
                        <div className="mood-item-img">
                            <img className="img-rectangle" src={RectangleImg} />
                        </div>
                        <div className="mood-item-progress bgColor6" style={{width: dealWithNum(mood.neutral, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.surprise}</div>
                        <div className="mood-item-img">
                            <img className="img-snow" src={SnowImg} />
                        </div>
                        <div className="mood-item-progress bgColor7" style={{width: dealWithNum(mood.surprise, emotionsTimes)}}></div>
                    </div>
                    <div className="mood-item">
                        <div className={i18n.lang == "en_us"? "mood-item-label english" : "mood-item-label"}>{i18n.report.sadness}</div>
                        <div className="mood-item-img">
                            <img className="img-water" src={WaterImg} />
                        </div>
                        <div className="mood-item-progress bgColor8" style={{width: dealWithNum(mood.sadness, emotionsTimes)}}></div>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="bulk-item bulk-right">
                <div className="bulk-content h289px">
                    <div className="bulk-content-title">{i18n.report.liveCharacteristics}：</div>
                    <div className="character-item-wrap">
                        <div className="character-item fontColor9">
                            <div className="character-circle bgColor9" style={{
                                width: dealWithNum(character.honesty ? character.honesty : character.sincerity),
                                height: dealWithNum(character.honesty ? character.honesty : character.sincerity)
                            }}></div>
                            <div className="character-subtitle">{character.honesty ? character.honesty : character.sincerity}</div>
                            <div className="character-title">{i18n.report.honesty}</div>
                        </div>
                        <div className="character-item fontColor10">
                            <div className="character-title">{i18n.report.confidence}</div>
                            <div className="character-subtitle">{character.confidence}</div>
                            <div className="character-circle bgColor10" style={{
                                width: dealWithNum(character.confidence),
                                height: dealWithNum(character.confidence)
                            }}></div>
                        </div>
                        <div className="character-item fontColor11">
                            <div className="character-circle bgColor11" style={{
                                width: dealWithNum(character.curiosity),
                                height: dealWithNum(character.curiosity)
                            }}></div>
                            <div className="character-subtitle">{character.curiosity}</div>
                            <div className="character-title">{i18n.report.curiosity}</div>
                        </div>
                        <div className="character-item fontColor12">
                            <div className="character-title">{i18n.report.passion}</div>
                            <div className="character-subtitle">{character.passion}</div>
                            <div className="character-circle bgColor12" style={{
                                width: dealWithNum(character.passion),
                                height: dealWithNum(character.passion)
                            }}></div>
                        </div>
                        {/* <div className="character-item">
                            <div className="character-title">{i18n.report.judging}</div>
                            <div className="character-subtitle">32</div>
                            <div className="character-circle bgColor1"></div>
                        </div>
                        <div className="character-item">
                            <div className="character-title">{i18n.report.disagree}</div>
                            <div className="character-subtitle">12</div>
                            <div className="character-circle bgColor1"></div>
                        </div> */}
                        <div className="character-item fontColor13">
                            <div className="character-circle bgColor13" style={{
                                width: dealWithNum(character.nervousness),
                                height: dealWithNum(character.nervousness)
                            }}></div>
                            <div className="character-subtitle">{character.nervousness}</div>
                            <div className="character-title">{i18n.report.nervousness}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
